define("shared/utils/plans-data/popular-features", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * @module Utils
   */

  /**
   * @class popularFeaturesMapUtil
   * @extends Utils
   */

  /**
   * Stores popular features accessible by plan type
   *
   * @method popularFeaturesMap
   * @param {Service} intl
   *
   * @returns {Object} Popular features per plan type
   */
  const popularFeaturesMap = intl => ({
    free: {},
    starter: {
      popularFeatures: [{
        title: intl.t('plans.highlight_mappings.hashtag_suggestions'),
        description: intl.t('plans.popular_features.description.hashtag_suggestions')
      }, {
        title: intl.t('plans.auto_publish_carousel_posts'),
        description: intl.t('plans.popular_features.description.auto_publish_carousel_posts')
      }, {
        title: intl.t('plans.popular_features.title.instagram_stories'),
        description: intl.t('plans.popular_features.description.instagram_stories')
      }, {
        title: intl.t('plans.popular_features.title.best_time_to_post'),
        description: intl.t('plans.popular_features.description.best_time_to_post')
      }]
    },
    growth: {
      popularFeatures: [{
        title: intl.t('plans.popular_features.title.full_analytics'),
        description: intl.t('plans.popular_features.description.full_analytics')
      }, {
        title: intl.t('plans.popular_features.title.custom_linkinbio'),
        description: intl.t('plans.popular_features.description.custom_linkinbio')
      }, {
        title: intl.t('plans.popular_features.title.team_management_tools'),
        description: intl.t('plans.popular_features.description.team_management_tools')
      }, {
        title: intl.t('plans.conversations'),
        description: intl.t('plans.popular_features.description.conversations')
      }]
    },
    advanced: {}
  });

  var _default = popularFeaturesMap;
  _exports.default = _default;
});